// extracted by mini-css-extract-plugin
export default {"container":"select_container__nKMgf","select":"select_select__lvhTq","error":"select_error__83yfF","asterisk":"select_asterisk__tcjWJ"};